export default ((src, {
  document = global.document,
  rejectOnError = true,
  attributes = {}
} = {}) => new Promise((resolve, reject) => {
  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  script.type = 'text/javascript';
  script.onerror = rejectOnError ? reject : resolve;
  script.onload = resolve;
  Object.keys(attributes).forEach(key => {
    script.setAttribute(key, attributes[key]);
  });
  document.body.appendChild(script);
}));